// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"ad8626c6","668":"4fc474c5"}[chunkId] + ".chunk.js";
};